module.exports = __webpack_public_path__ + "static/mo21-d24e4b121ed3a16bc74cd2d3aaf9f4a7.png";